import { DifficultyTier, ShopItem, ShopItemId } from '../engine/types';

// Prices are Blackout Bucks (B$, game money), not real quotes — sized so each tier forces a real tradeoff.
export const SHOP_ITEMS: Record<ShopItemId, ShopItem> = {
  [ShopItemId.BATTERY]: {
    description: 'Keeps the essentials running when the grid can’t. Each unit adds capacity.',
    id: ShopItemId.BATTERY,
    maxQuantity: 2,
    name: 'Battery backup',
    price: 5000,
  },
  [ShopItemId.EFFICIENCY_PACK]: {
    description: 'Efficient appliances and LED everything. Every load draws less.',
    id: ShopItemId.EFFICIENCY_PACK,
    maxQuantity: 1,
    name: 'Efficiency upgrade',
    price: 2000,
  },
  [ShopItemId.INSULATION]: {
    description: 'Keeps the indoor temperature from chasing the weather outside.',
    id: ShopItemId.INSULATION,
    maxQuantity: 1,
    name: 'Insulation & air sealing',
    price: 2000,
  },
  [ShopItemId.SOLAR_LARGE]: {
    description: 'A big rooftop array. Strong daytime generation, weather permitting.',
    excludes: ShopItemId.SOLAR_SMALL,
    id: ShopItemId.SOLAR_LARGE,
    maxQuantity: 1,
    name: 'Solar — large array',
    price: 6000,
  },
  [ShopItemId.SOLAR_SMALL]: {
    description: 'A starter rooftop array. Modest daytime generation.',
    excludes: ShopItemId.SOLAR_LARGE,
    id: ShopItemId.SOLAR_SMALL,
    maxQuantity: 1,
    name: 'Solar — small array',
    price: 4000,
  },
};

export const DIFFICULTY_TIERS: DifficultyTier[] = [
  {
    budget: 18000,
    description: 'Room for battery, solar, and upgrades. Build the fortress.',
    id: 'comfortable',
    name: 'Comfortable',
  },
  {
    budget: 12000,
    description: 'Enough for the essentials — if you choose wisely.',
    id: 'tight',
    name: 'Tight',
  },
  {
    budget: 7000,
    description: 'Every Blackout Buck counts. Good luck out there.',
    id: 'shoestring',
    name: 'Shoestring',
  },
];

/** eu of storage per battery unit purchased */
export const BATTERY_EU_PER_UNIT = 14;
/** peak eu/hr generation by array size */
export const SOLAR_PEAK_EU_PER_HOUR = { large: 6, none: 0, small: 3 };
/** multiplier applied to all drains with the efficiency pack */
export const EFFICIENCY_DRAIN_FACTOR = 0.7;
/** indoor temp drift toward outdoor, fraction per game hour */
export const LEAK_RATE_PER_HOUR = { insulated: 0.03, standard: 0.09 };
